import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ConfirmButtonCustom } from '../../Forms';

const OkayButton = ({ execute }) => {
  const { t } = useTranslation();
  return (
    <>
      <ConfirmButtonCustom
        block="true"
        style={{ background: '#489ED7', borderColor: '#489ED7' }}
        onClick={() => execute()}
        size="large"
        type="primary"
      >
        {t('FORM_USER_ACCOUNT.OK')}
      </ConfirmButtonCustom>
    </>
  );
};

export default OkayButton;

OkayButton.propTypes = {
  execute: PropTypes.func.isRequired,
};
